module.exports = __webpack_public_path__ + "static/kyeonga.jeon-f40ba7dc2ef095b14e2202a32168817f.jpeg";